
/* eslint-disable no-unused-vars */

// Largo máximo de un RUT escrito con formato: 12.345.678-9
export const RUT_MAX_LENGTH = 12;

// Deja solo los caracteres que pueden formar parte de un RUT, para no permitir
// que se escriba cualquier cosa en el input
export const sanitizeRutInput = (value) =>
    String(value ?? "")
        .replace(/[^0-9kK.-]/g, "")
        .slice(0, RUT_MAX_LENGTH);

// Quita puntos, guiones y espacios para dejar solo cuerpo + dígito verificador
export const cleanRut = (rut) =>
    String(rut ?? "")
        .toLowerCase()
        .replace(/[.\s-]/g, "");

export const isRutValid = (rut) => {
    if (!rut) return false;

    let sum = 0;
    const rut_clean = cleanRut(rut);

    // Formato estricto: 7 u 8 dígitos de cuerpo + dígito verificador (0-9 o k).
    // Cualquier otro carácter invalida el RUT en vez de ser ignorado.
    if (!/^\d{7,8}[\dk]$/.test(rut_clean)) return false;

    const rut_body = rut_clean.slice(0, -1);
    const rut_vd = rut_clean.slice(-1);
    const multipliers = [2, 3, 4, 5, 6, 7];

    for (let i = 0; i < rut_body.length; i++) {
        const num = rut_body[rut_body.length - 1 - i];
        const by =
            i < multipliers.length
                ? multipliers[i]
                : multipliers[i % multipliers.length];
        const subtotal = num * by;
        sum += num * by;
    }

    const vd = 11 - (sum % 11);
    if (vd === 10 && rut_vd === "k") return true;
    if (vd === 11 && rut_vd === "0") return true;
    if (String(vd) === rut_vd) return true;

    // console.log({rut, rut_clean, rut_body, rut_vd, sum, vd});
    return false;
};
